export default __webpack_public_path__ + "static/media/boxProduct.31fba295.svg";